export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: 2900,
    backgroundColor: theme.palette.green.main,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: 2900,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: 938,
    background: `no-repeat url(${theme.url('/blocks/b5-bg-left.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'left',
  },
  greenCurve: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    height: '100%',
    width: '70vw',
    background: `no-repeat url(${theme.url('/blocks/b5-green-curve.svg')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right top',
  },
  blur: {
    position: 'absolute',
    zIndex: 1,
    background: 'rgba(255, 255, 255, 0)',
    backdropFilter: 'blur(12px)',
    height: '100%',
    width: 938,
  },
  mainTitle: {
    zIndex: 2,
    position: 'absolute',
    bottom: '8%',
    left: '6%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 0,
      left: 0,
      textAlign: 'right',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      color: theme.palette.primary.main,
    },
  },
  subtitle: {
    zIndex: 2,
    position: 'absolute',
    bottom: 'calc(50% - 300px)',
    left: 938,
    transform: 'translateX(-50%)',
    width: 600,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.grey.light,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 0,
      left: 0,
      padding: theme.spacing(2),
      color: theme.palette.primary.main,
      width: '80%',
      transform: 'initial',
      margin: `${theme.spacing(2)}px auto ${theme.spacing(2)}px auto`,
    },
  },
  content: {
    position: 'relative',
    zIndex: 5,
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  card1: {
    position: 'absolute',
    top: '10vh',
    left: 938,
    transform: 'translateX(-50%)',
  },
  card2: {
    position: 'absolute',
    top: 0,
    left: 1300,
  },
  card3: {
    position: 'absolute',
    top: '50vh',
    left: 2000,
    transform: 'translateX(-100%)',
  },
  card4: {
    position: 'absolute',
    top: '50vh',
    left: 2000,
    transform: 'translateY(-100%)',
  },
  card5: {
    position: 'absolute',
    top: '55vh',
    left: 2200,
  },
  cardMobile: {
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      margin: `${theme.spacing(2)}px auto ${theme.spacing(2)}px auto`,
      transform: 'initial',
      textAlign: 'center',
    },
  },
});
